import { RequestType } from "~/features/navbar/RequestTypeModal";
import { SupportBundle } from "~/features/supportBundle/supportBundle.slice";
import {
  AndonWorkstationQuery,
  AndonWorkstationsResponse,
  ToggleHandRequest
} from "~/types/api";

import { warehouseApi } from "./warehouseApi";

export type GetAndonWorkstationsArg =
  | (Partial<AndonWorkstationQuery> & {
      fulfillmentCenterId?: string;
    })
  | void;

export const andonApi = warehouseApi.injectEndpoints({
  endpoints: (build) => ({
    toggleHandRaise: build.mutation<
      void,
      {
        autostoreGridId: Guid;
        workstationId: Guid;
        raiseHand: boolean;
        requestType?: RequestType;
      }
    >({
      query: ({ autostoreGridId, workstationId, raiseHand, requestType }) => ({
        url: `/autostore-grid/${autostoreGridId}/workstation/${workstationId}/toggle-hand-raise`,
        method: "POST",
        body: { raiseHand, requestType } as ToggleHandRequest & {
          requestType?: RequestType;
        }
      })
    }),
    getAndonWorkstations: build.query<
      AndonWorkstationsResponse,
      GetAndonWorkstationsArg
    >({
      query: ({ workstationIds, fulfillmentCenterId } = {}) => ({
        url: `/andon/workstations`,
        method: "GET",
        params: {
          ...(workstationIds?.length && { workstationIds }),
          ...(fulfillmentCenterId && { fulfillmentCenterId })
        }
      }),
      providesTags: ["andon workstations"]
    }),
    sendSupportBundle: build.mutation<void, SupportBundle>({
      query: (supportBundle) => ({
        method: "POST",
        // Placeholder for now as this endpoint doesn't exist yet.
        url: "/support-bundle",
        body: supportBundle
      })
    })
  })
});
